<section class="pb-4">
    <h3 class="px-2 mb-0">{{ 'pages.cybersocxdr.dashboard.fieldTitles.slaFull' | translate }}</h3>
    <div class="dropdown-divider"></div>
    <table *ngIf="slaInfo" style="table-layout: fixed" class="table table-hover table-striped-columns text-center">
        <caption class="d-none"> {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaFull' | translate }} </caption>
        <thead>
            <tr>
                <th scope="col" class="py-1">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.priority' | translate }}
                </th>
                <th scope="col" class="py-1">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaSchedule' | translate }}
                </th>
                <th scope="col" class="py-1">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaNotificationTime' | translate }}
                </th>
                <th scope="col" class="py-1">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaInvestigationTime' | translate }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let priority of objectValues(slaInfo); index as i">
                <th scope="row" class="font-weight-bold">P{{ i + 1 }}</th>
                <td>{{ priority.horaire | anonymise }}</td>
                <td>{{ parseSLA(priority.timenotif) | anonymise }}</td>
                <td>{{ parseSLA(priority.timeinvest) | anonymise }}</td>
            </tr>
        </tbody>
    </table>

    <ul *ngIf="additionalInfo">
        <li *ngFor="let information of additionalInfo.contract_info">
            {{ information | anonymise }}
        </li>
    </ul>
</section>